import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class Setting extends BaseModel {
  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
  }
}

decorate(Setting, {
  id: observable,
  workplaceId: observable,
  workplace: observable,
  terminalLayoutId: observable,
  terminalLayout: observable,
  identifier: observable,
  value: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
